const initialConceptualSchema = () =>
  import(
    /* webpackChunkName: "initialConceptualSchema" */
    "@/components/ssp/missions/mission/site/partials/schema-program/InitialConceptualSchema.vue"
  );

const updatedConceptualSchema = () =>
  import(
    /* webpackChunkName: "updatedConceptualSchema" */
    "@/components/ssp/missions/mission/site/partials/schema-program/UpdatedConceptualSchema.vue"
  );

const provisionalProgram = () =>
  import(
    /* webpackChunkName: "provisionalProgram" */
    "@/components/ssp/missions/mission/site/partials/schema-program/ProvisionalProgram.vue"
  );
const investigationProgramComparaison = () =>
  import(
    /* webpackChunkName: "investigationProgramComparaison" */
    "@/components/ssp/missions/mission/site/partials/schema-program/InvestigationProgramComparaison.vue"
  );

export default [
  {
    path: "",
    name: "initial-conceptual-schema",
    component: initialConceptualSchema,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "updated-conceptual-schema",
    name: "updated-conceptual-schema",
    component: updatedConceptualSchema,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "provisional-program",
    name: "provisional-program",
    component: provisionalProgram,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "investigation-program-comparaison",
    name: "investigation-program-comparaison",
    component: investigationProgramComparaison,
    meta: {
      showSubNavBar: true,
    },
  },
];
